module.exports = __webpack_public_path__ + "img/31.3578d3bd.jpg";